export default __webpack_public_path__ + "static/media/google_icon.66fac22e.png";